module.exports = __webpack_public_path__ + "static/p2-dc7c7438fb37d7ec385c2a22fe054780.jpg";